import { Controller } from 'stimulus'
import { inIframe, isMessageEvent } from 'iframe/helpers'

export default class extends Controller {
  static targets = ['link']

  connect = async (): Promise<void> => {
    if (inIframe()) {
      const link = this.linkTarget
      const url = new URL(link.href)
      url.searchParams.append('embedding_url', (await this.embeddingDomain()))
      link.href = url.toString()
    }
  }

  embeddingDomain = async (): Promise<string> => {
    return await new Promise((resolve, reject) => {
      const onMessage = (e): void => {
        if (isMessageEvent(e, 'clara-urlvalue')) {
          window.removeEventListener('message', onMessage)
          resolve(this.domainFromUrl(e.data.value))
        }
      }
      window.addEventListener('message', onMessage)

      const message = {
        type: 'clara-geturl'
      }
      window.parent.postMessage(message, '*')
    })
  }

  domainFromUrl = (url: string): string => {
    const urlObject = new URL(url)
    return `${urlObject.protocol}//${urlObject.host}`
  }
}
